import React from 'react';
import PropTypes from 'prop-types';
import { track } from '@app/helpers/analytics';

const withClickTracking = WrappedComponent => {
  const Wrapper = ({
    forwardedRef,
    event,
    onClick = () => {},
    disableTracking = false,
    ...rest
  }) => {
    const handleClick = (...args) => {
      const { eventType, ...properties } = event;

      if (!disableTracking) {
        track(eventType, properties);
      }

      onClick(...args);
    };

    return (
      <WrappedComponent ref={forwardedRef} onClick={handleClick} {...rest} />
    );
  };

  Wrapper.propTypes = {
    disableTracking: PropTypes.bool,
    dispatch: PropTypes.func,
    event: PropTypes.shape({
      eventType: PropTypes.string.isRequired,
    }).isRequired,
    forwardedRef: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.any }),
    ]),
    onClick: PropTypes.func,
  };

  return React.forwardRef((props, ref) => (
    <Wrapper forwardedRef={ref} {...props} />
  ));
};

export default withClickTracking;
